import React from 'react';
import PersonIcon from 'material-ui/svg-icons/social/person';
import MailIcon from 'material-ui/svg-icons/communication/email';
import DateIcon from 'material-ui/svg-icons/social/cake';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import StarIcon from 'material-ui/svg-icons/action/stars';
import EurosIcon from 'material-ui/svg-icons/action/euro-symbol';
import moment from './../utils/moment_fr';
import RaisedButton from "material-ui/RaisedButton";
import {Link} from 'react-router-dom'


export default (p) => (
    <div>
        <div className={'row'}>
            <div className={'col'}>
                <div style={{display: 'inline-flex', verticalAlign: 'middle'}}>
                    <PersonIcon style={{width: 18, height: 18, marginRight: 8}}/>{p.user.nom + ' ' + p.user.prenom}
                </div>
                <br/><br/>
                <div style={{display: 'inline-flex', verticalAlign: 'middle'}}>
                    <MailIcon style={{width: 18, height: 18, marginRight: 8}}/>{p.user.email}
                </div>
                <br/><br/>
                <div style={{display: 'inline-flex', verticalAlign: 'middle'}}>
                    <DateIcon style={{
                        width: 18,
                        height: 18,
                        marginRight: 8
                    }}/>{moment(p.user.date_naissance).format('DD/MM/YYYY')}
                </div>
            </div>
            <div className={'col'}>
                <div style={{display: 'inline-flex', verticalAlign: 'middle'}}>
                    <SchoolIcon style={{width: 18, height: 18, marginRight: 8}}/>{p.user.intitule_formation}
                </div>
                <br/><br/>
                <div style={{display: 'inline-flex', verticalAlign: 'middle'}}>
                    <StarIcon style={{width: 18, height: 18, marginRight: 8}}/>{p.user.classification}
                </div>
                <br/><br/>
                <div style={{display: 'inline-flex', verticalAlign: 'middle'}}>
                    <EurosIcon
                        style={{
                            width: 18,
                            height: 18,
                            marginRight: 8
                        }}/>{"Budget CPF mobilisable (euros) : " + p.user.budget_cpf}
                </div>
            </div>
        </div>
        <Link to="/salarie/infos-personnelles">
            <RaisedButton
                style={{marginTop: 25}}
                primary={true}
                label={'Mettre à jour vos informations personnelles'}
            />
        </Link>
    </div>
);


// WEBPACK FOOTER //
// ./src/components/shared/pages/userInfos.js